import { render, staticRenderFns } from "./imported_debtors.vue?vue&type=template&id=f2024204&"
import script from "./imported_debtors.vue?vue&type=script&lang=js&"
export * from "./imported_debtors.vue?vue&type=script&lang=js&"
import style0 from "./imported_debtors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports